// Platform ticketing integration config (support-service via the gateway).
// Auth + CSRF are handled globally by the axios interceptors (cookie session).
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);
const BASE = `${API_V1}/support/admin/ticketing`;

export type TicketingProvider = 'none' | 'mock' | 'jira';

export interface TicketingConfig {
  provider: TicketingProvider;
  enabled: boolean;
  jira_base_url: string;
  jira_project_key: string;
  jira_email: string;
  jira_issue_type: string;
  token_set: boolean; // whether an encrypted API token is stored (never the value)
  updated_by?: string;
  updated_at?: string;
}

export interface TicketingConfigInput {
  provider: TicketingProvider;
  enabled: boolean;
  jira_base_url: string;
  jira_project_key: string;
  jira_email: string;
  jira_issue_type: string;
  api_token?: string; // write-only; omit/blank to keep the stored token
}

export interface TestResult {
  ok: boolean;
  provider?: string;
  error?: string;
}

export const getTicketingConfig = () =>
  axios.get<TicketingConfig>(`${BASE}/config`).then((r) => r.data);

export const saveTicketingConfig = (input: TicketingConfigInput) =>
  axios.put<TicketingConfig>(`${BASE}/config`, input).then((r) => r.data);

export const testTicketingConfig = () =>
  axios.post<TestResult>(`${BASE}/config/test`, {}).then((r) => r.data);
